export default __webpack_public_path__ + "static/media/ic_ios_share.2069a721.svg";